import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export interface EnrichmentStatus {
  jobId: string;
  leadId: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  currentStep: number;
  totalSteps: number;
  stepName: string;
  errorMessage: string | null;
}

export function useEnrichmentStatus(jobId: string | undefined) {
  return useQuery({
    queryKey: ['enrichment', jobId],
    queryFn: () => apiFetch<EnrichmentStatus>(`/api/enrichment/${jobId}/status`),
    enabled: !!jobId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'completed' || status === 'failed') return false;
      return 2000;
    },
  });
}
